import $ from 'expose-loader?exposes=$,jQuery!jquery'
import { Tooltip } from 'expose-loader?exposes=bootstrap!bootstrap'
import Swal from 'sweetalert2'
import autosize from 'autosize'
import Splide from '@splidejs/splide'
import { defaults, defaultModules, Stack } from '@pnotify/core'
import * as PNotifyFontAwesome5Fix from '@pnotify/font-awesome5-fix'
import * as PNotifyFontAwesome5 from '@pnotify/font-awesome5'
import {
  ajaxUpdate,
  debounce,
  filterApply,
  filterReset,
  getParameterByName,
  parseResponse
} from './utils'
import {
  addScrollBars,
  slidesCallback,
  initNavtabs,
  initNavtabsScroll,
  paginationLi,
  tableSplitToPages,
  initCCard,
  onLanguageChange,
  onSelectAllTld, mountPageScrollbars, processScroll
} from './ui'
import HBFiles from './hbfiles'
import { getCookie, setCookie } from './hostbill'
import { bindFileUpload, parseFormPlaceholders } from './form'
import * as PNotifyBootstrap5 from './pnotify/bootstrap5'

const CSRFProtection = xhr => {
  const token = $('meta[name="csrf-token"]').attr('content')
  if (token) {
    xhr.setRequestHeader('X-CSRF-Token', token)
  }
}

let unload_timer
// remove preloader after page is rendered
$(window).on('load', function () {
  $('.pageloader-wrapper').fadeOut('fast')
  clearTimeout(unload_timer)
})

let loaders = new Array

function appendLoader(loadername) {
  loaders[loaders.length] = loadername
}

$(document).ready(function () {
  if ('ajaxPrefilter' in $) {
    $.ajaxPrefilter(function (options, originalOptions, xhr) {
      CSRFProtection(xhr)
    })
  } else {
    $(document).ajaxSend(function (e, xhr) {
      CSRFProtection(xhr)
    })
  }

  $('[data-bs-toggle="tooltip"]').each(function() {
    new Tooltip(this)
  })

  $('.sh1a .orderboxpadding').on('click', function () {
    const e = $(this).parent().find('.subdesc_').eq(0)
    if ($(e).is(':visible')) {
      $(e).hide()
    } else {
      $(e).show()
    }
  })

  defaultModules.set(PNotifyBootstrap5, {})
  defaultModules.set(PNotifyFontAwesome5Fix, {})
  defaultModules.set(PNotifyFontAwesome5, {})

  defaults.styling = 'bootstrap5'

  if (typeof window.pnotifyStack === 'undefined') {
    window.pnotifyStack = {
      topleft: new Stack({
        dir1: 'down',
        dir2: 'right',
        push: 'top',
        maxStrategy: 'close'
      }),
      bottomleft: new Stack({
        dir1: 'right',
        dir2: 'up',
        push: 'top',
        maxStrategy: 'close'
      }),
      bottomright: new Stack({
        dir1: 'up',
        dir2: 'left',
        firstpos1: 25,
        firstpos2: 25
      }),
      modal: new Stack({
        dir1: 'down',
        dir2: 'right',
        push: 'top',
        maxStrategy: 'close',
        modal: true,
        overlayClose: true
      })
    }
  }

  $('a.sortorder').on('click', function () {
    $('#updater').addLoader()
    $('#checkall').attr('checked', false)

    const currentList = $('#currentlist')
    currentList.attr('href', $(this).attr('href'))

    if (
      $(this).attr('href').substring($(this).attr('href').lastIndexOf('|')) === '|ASC'
    ) {
      $(this).attr(
        'href',
        $(this).attr('href').substring(0, $(this).attr('href').lastIndexOf('|')) + '|DESC'
      )
    }
    else {
      $(this).attr('href', $(this).attr('href').substring(0, $(this).attr('href').lastIndexOf('|')) + '|ASC');
    }

    ajaxUpdate(currentList.attr('href'), {
      page: $('#currentpage').val(),
      layer: 'ajax'
    }, '#updater')
    return false
  })

  $('#pageswitch button').on('click', function () {
    const p = parseInt($(this).text()) - 1
    $('#currentpage').val(p).change()
    return false
  })

  $('ul[rel].pagination ').each(function () {
    paginationLi.call(this)
    // $('#currentpage').val(p).change()
  })

  $('#currentpage').on('change', () => {
    $('#updater').addLoader()
    $('#checkall').attr('checked', false)
    ajaxUpdate($('#currentlist').attr('href'), {
      page: $('#currentpage').val(),
      layer: 'ajax'
    }, '#updater')
  })

  $(document).ajaxSend((a, b, c) => {
    const page = parseInt(getParameterByName('page', '?' + c.data))
    if (!isNaN(page)) {
      $('ul[rel].pagination').each(function () {
        paginationLi.call(this, page + 1)
      })
    }
  })

  $('.submiter').on('click', function () {
    $('#updater').addLoader()
    $('#checkall').attr('checked', false)
    let pushs = ''
    if ($(this).attr('queue')) {
      pushs = 'push'
    }
    ajaxUpdate($('#currentlist').attr('href') + '&' + $('#testform').serialize() + '&' + $(this).attr('name'), {
      layer: 'ajax',
      stack: pushs
    }, '#updater')
    return false
  })

  setTimeout(function () {
    const errors = $('#errors')
    if (errors.find('span').length > 0) {
      errors.slideDown()
    }

    const infos = $('#infos')
    if (infos.find('span').length > 0) {
      infos.slideDown()
    }
  }, 30)

  if (loaders.length > 0) {
    let i = 0
    for (i = 0; i < loaders.length; i++) {
      if (loaders[i] === 'flyingSidemenu') {
        continue
      }
      window[loaders[i]]()
    }
  }

  let e = 0,
    w = 100
  const u = $('.pa1 a', '#submenu')
  const l = u.length
  u.each(function (o) {
    if (e === 0 && $(this).width() + $(this).position().left > 960) {
      e = o
    }
    if ($(this).width() > w)
      w = $(this).width()
  })
  if (e > 0) {
    const d = $('<ul class="dropdown-menu"></ul>'),
      a = $('<a class="dropdown-toggle" data-bs-toggle="dropdown" href="#"></a>')
        .text('More')
        .append($('<b class="caret"></b>')),
      more = $('<li class="dropdown"></li>').append(a)
    for (i = l; i >= e; i--) {
      d.prepend(u.eq(i))
    }
    more.append(d)
    $('.pa1', '#submenu').append(more)
  }

  let $win = $(window),
    $nav = $('#mainmenu'),
    navTop = $nav.length && $nav.offset().top,
    isFixed = 0

  if ($('#cart').length && $('#sidemenu').length && $('#floater').length) {
    $win.on('scroll', processScroll)
  }

  $('#ticketmessage').ajaxHint()

  initNavtabs()

  if ($(window).width() > 993) {
    if (getCookie('leftmenu_hide')) {
      $('body').addClass('sidenav-toggled')
    }
  } else if ($(window).width() < 993) {
    $('body').removeClass('sidenav-toggled')
  }

  HBFiles.init()

  $(window).on('beforeunload', function (e) {
    setTimeout(function () {
      $('.pageloader-item').show()
      $('.pageloader-wrapper').fadeIn('fast')
    }, 600)
  })

  $(window).on('resize', function () {
    $('.nav-tabs-wrapper .nav-tabs').each(function (i) {
      initNavtabsScroll($(this))
    })
    $('.dropdown-menu-shoppingcart').css({width: $('.section-main').width() * .5})
    if ($(window).width() < 993) {
      $('body').removeClass('sidenav-toggled')
    }
  })

  $('.navbar .btn-toggler').on('click', event => {
    event.preventDefault()
    const body = $('body')
    body.toggleClass('sidenav-toggled')
    if ($(window).width() > 993) {
      setCookie('leftmenu_hide', body.hasClass('sidenav-toggled'), 30)
    }
  })

  $('.sidebar-overlay').on('click', event => {
    event.preventDefault()
    const body = $('body')
    body.toggleClass('sidenav-toggled')
    if ($(window).width() > 993) {
      setCookie('leftmenu_hide', body.hasClass('sidenav-toggled'), 30)
    }
  })

  mountPageScrollbars()

  let finditem = true,
    ahref = false

  $('.template_2019_custom .sidebar a').removeClass('active')
  $('.template_2019_custom .nav-tabs a:not([data-toggle])').each(function () {
    const selfb = $(this)
    $('.template_2019_custom .sidebar a:not([data-toggle])').each(function () {
      const selfa = $(this)
      if (selfb.attr('href').toLowerCase() === selfa.attr('href').toLowerCase()) {
        ahref = selfa
        finditem = false
        return true
      }
    })
  })
  if (finditem) {
    let chref = 0
    $('.template_2019_custom .sidebar a:not([data-toggle])')
      .each(function () {
        const selfa = $(this),
          hrefa = selfa.attr('href').toLowerCase()
        if (window.location.href.toLowerCase().indexOf(hrefa) >= 0) {
          if (hrefa.length > chref) {
            chref = hrefa.length
            ahref = selfa
          }
          finditem = false
        }
      })
      .on(
        'click',
        e => localStorage.setItem('activeMenuItem', $(e.target).attr('href'))
      )
  }

  if (ahref) {
    $(ahref).addClass('active')
  } else if (finditem) {
    const activeItem = localStorage.getItem('activeMenuItem')
    if (activeItem) {
      $(`.template_2019_custom .sidebar a[href="${activeItem}"]`).addClass('active')
    }
  }

  $('.table').on('show.bs.dropdown', function (e) {
    $(e.target).closest('tr').css('overflow', 'visible')
    $(this).css('overflow', 'inherit')
    $(this).closest('.table-responsive').css('overflow', 'visible')
  }).on('hide.bs.dropdown', function (e) {
    $(e.target).closest('tr').css('overflow', 'hidden')
    $(this).css('overflow', 'visible')
    $(this).closest('.table-responsive').css('overflow', 'hidden')
  })

  const addSshBtn = $('#addssh-btn')
  $('#ssh-tab')
    .on('shown.bs.tab', e => addSshBtn.show())
    .on('hidden.bs.tab', e => addSshBtn.hide())

  $('#service-filters').on('click', function () {
    const self = $(this),
      box = $('#' + self.attr('data-box'))
    box.fadeToggle('fast')
    self.toggleClass('shown')
  })

  const navBarSearchLoader = $('.navbar-search-loader')
  $('.navbar-search')
    .on('keyup keypress', function (e) {
      const keyCode = e.keyCode || e.which
      if (keyCode === 13) {
        e.preventDefault()
        return false
      }
    })
    .search({
      type: 'category',
      apiSettings: {
        url: '?cmd=search&query={query}',
        onResponse: () => navBarSearchLoader.removeClass('active')
      },
      showNoResults: true,
      duration: 0,
      transition: false,
      maxResults: 10,
      hideDelay: 0,
      searchDelay: 200,
      easing: false,
      minCharacters: 2,
      fields: {
        categories: 'results',     // array of categories (category view)
        categoryName: 'name',        // name of category (category view)
        categoryResults: 'results',     // array of results (category view)
        title: 'title',       // result title
        action: 'action',      // "view more" object name
        actionText: 'title',        // "view more" text
        actionURL: 'url'          // "view more" url
      },
      fullTextSearch: false,
      onSelect: e => e.preventDefault(),
      onSearchQuery: () => navBarSearchLoader.addClass('active'),
      onResultsAdd: () => {
        navBarSearchLoader.removeClass('active')
        $('.main-overlay').addClass('active')
      },
      onResultsOpen: () => {
        $('.navbar-search-results').addClass('show').show()
        $('.dropdown-order-items').removeClass('show').hide()
      },
      onResultsClose: function () {
        navBarSearchLoader.removeClass('active')
        $('.main-overlay').removeClass('active')
      },
      selector: {
        results: '.navbar-search-results',
      },
      error: {
        source: jsLang.search.error.source ? jsLang.search.error.source : 'Cannot search. No source used, and Semantic API module was not included',
        noResults: jsLang.search.error.noResults ? jsLang.search.error.noResults : 'Your search returned no results',
        logging: jsLang.search.error.logging ? jsLang.search.error.logging : 'Error in debug logging, exiting.',
        noEndpoint: jsLang.search.error.noEndpoint ? jsLang.search.error.noEndpoint : 'No search endpoint was specified',
        noTemplate: jsLang.search.error.noTemplate ? jsLang.search.error.noTemplate : 'A valid template name was not specified.',
        oldSearchSyntax: jsLang.search.error.oldSearchSyntax ? jsLang.search.error.oldSearchSyntax : 'searchFullText setting has been renamed fullTextSearch for consistency, please adjust your settings.',
        serverError: jsLang.search.error.serverError ? jsLang.search.error.serverError : 'There was an issue querying the server.',
        maxResults: jsLang.search.error.maxResults ? jsLang.search.error.maxResults : 'Results must be an array to use maxResults setting',
        method: jsLang.search.error.method ? jsLang.search.error.method : 'The method you called is not defined.'
      }
    })

  $('.pill-select').on('click', function () {
    const itemsType = $(this).attr('data-items'),
      countVisible = $(this).closest('.info-box').find('.pill-select').length
    if (itemsType === 'all') {
      $(this).closest('.info-box').find('.pill-item').slice(0, countVisible).show().addClass('__visible')
    } else {
      $(this).closest('.info-box').find('.pill-item').hide().removeClass('__visible');
      $(this).closest('.info-box').find('.pill-item[data-item="' + itemsType + '"]').slice(0, countVisible).show().addClass('__visible')
    }
  })

  $(document).on('click', e => {
    if (
      $(e.target).hasClass('navbar-order') ||
      $(e.target).closest('.navbar-order').length
    ) {
      if (
        $(e.target).hasClass('navbar-order-toggler') ||
        $(e.target).parents('.navbar-order-toggler').length
      ) {
        e.preventDefault()
      }

      if ($(e.target).parents('.dropdown-order-items').length) {
        return
      }

      const toggl = $('.navbar-order .navbar-order-toggler')
      toggl.toggleClass('show')
      if (toggl.hasClass('show')) {
        $('.dropdown-order-items').addClass('show').show()
        $('.main-overlay').addClass('active')
        $('.navbar-search-results').removeClass('show').hide()
      } else {
        $('.dropdown-order-items').removeClass('show').hide()
        $('.main-overlay').removeClass('active')
      }
    } else {
      $('.dropdown-order-items').removeClass('show').hide()
      $('.main-overlay').removeClass('active')
    }
  })

  const formLabel = $('.form-label-group')
  formLabel.on('input change focus blur click', function () {
    parseFormPlaceholders(this)
  })

  $(document).ajaxComplete(function () {
    formLabel.each(function () {
      parseFormPlaceholders(this)
    })
  })

  formLabel.each(function () {
    parseFormPlaceholders(this)
  })

  $('.vtip_description').on('click', e => e.preventDefault())

  $('.info-box-select-list').on('click', function (e) {
    e.preventDefault()
    const list = $(this).attr('data-select-list')
    $(this).closest('.info-boxes').find('.info-box').hide()
    $(this).closest('.info-boxes').find('.info-box[data-infobox-list="' + list + '"]').show()
  })

  autosize($('.textarea-autoresize'))
  $('#main-side')
    .on('mouseenter', function () {
      $(this).addClass('hover')
    })
    .on('mouseleave', function () {
      $(this).removeClass('hover')
    })
    .on('hover', function () {
      $('#main-side nav').height($('#page').height() - $('#section-border').outerHeight(true) - $('#main-side header').outerHeight(true))
    }, () => setTimeout(() => $('#main-side nav').height(''), 100))

  $('#board-tickets').on('click', '.ticket-list a, .ticket-controls .pull-right a', function (e) {
    e.preventDefault()
    const url = $(this).attr('href'),
      list = $('#board-tickets .ticket-list'),
      view = $('#board-tickets .ticket-view')
    let active = list.find('a[href="' + url + '"]:visible')

    $.get(url, data => {
      data = theme.parseResponse(data)
      if (data.length) {
        view.stop().html(data).animate({opacity: 1}, 150)
        addScrollBars(view.find('.content-scroll'))
      }
    })

    if (active.length) {
      active = active.parent()
      const scrollbar = list.data('scrollbar')
      const { viewport } = scrollbar.elements()
      const scrollPos = active.prevAll(':visible').length * active.height(),
        scrollOffset = viewport.scrollTop || 0

      active.addClass('active').siblings('.active').removeClass('active')
      view.animate({opacity: 0.2}, 500)
      if (scrollPos >= scrollOffset + list.height()) {
        list.scrollTo({
          left: 0,
          top: scrollPos - list.height() + active.height()
        })
      } else if (scrollPos < scrollOffset) {
        list.scrollTo({
          left: 0,
          top: scrollPos
        })
      }
    }

    return false
  })

  $('#dashboard_services a.nav-link').on('click', function () {
    const itms = $(this).attr('data-items'),
      ttle = $('#dashboard_services_list_total_title')

    ttle.html(itms === 'domains' ? ttle.attr('data-title-domains') : ttle.attr('data-title-services'))
    $('#dashboard_services_list tbody tr').addClass('hidden').hide()
    $('#dashboard_services_list tbody tr[data-item="' + itms + '"]').removeClass('hidden').show()
  })

  addScrollBars($('.content-scroll'))

  tableSplitToPages('#board-services', 'tr')
  tableSplitToPages('#board-invoices')

  $('.slide-left, .slide-right', '#board-services').on('click', slidesCallback)
  $('.slide-left, .slide-right', '#board-invoices').on('click', slidesCallback)

  const slides = $('#slides')
  if (slides.length > 0) {
    new Splide(slides, {
      perPage: 4,
      pagination: true,
      breakpoints: {
        768: {perPage: 1},
        1200: {perPage: 2},
        1400: {perPage: 3}
      }
    }).mount()
  }

  $('[data-bs-toggle=dropdown][data-contener]').on('click.dropdown.data-api', function (e) {
    const self = $(this),
      parent = self.parent(),
      target = $(e.target)

    if (target.is('.dropdown-clone') || target.parents('.dropdown-clone').length) {
      return false
    }

    const clone = parent.clone(true)
      .css({
        position: 'absolute',
        top: 0,
        left: 0
      })
      .addClass('not-cart dropdown-clone')
      .data('dropdown-clone', parent)
      .appendTo(self.data('contener'))

    clone.children().each(function (i) {
      const org = parent.children().eq(i),
        elm = $(this)
      elm.css('position', 'absolute')
        .css(org.offset())
        .width(org.width()).height(org.height())
    })

    clone.on('click', 'a', () => {
      clone.data('dropdown-clone').css({visibility: 'visible'})
      clone.remove()
    })

    parent.css({visibility: 'hidden'})
  }).on('click.dropdown.data-api', function () {
    $('[data-bs-toggle=dropdown][data-contener]').each(function () {
      const self = $(this).parent()
      if (self.data('dropdown-clone')) {
        self.data('dropdown-clone').css({visibility: 'visible'})
        self.remove()
      }
    })
  })

  $('#checkall').on('change', function () {
    const checkbox = $(this).closest('table').find('.checkme').not(":disabled")
    if (this.checked) {
      checkbox.prop('checked', true).trigger('change')
    } else {
      checkbox.prop('checked', false).trigger('change')
    }
  })

  $('[data-sorter]').on('click', function (e) {
    e.preventDefault()
    const self = $(this),
      list = $('#currentlist')

    let url = list.attr('href'),
      sortval = self.attr('href')

    const sortkey = self.data('sorter'),
      valmatch = sortval.match(
        new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?')
      )

    if (valmatch) {
      sortval = valmatch[1] || '';
      url = url.replace(new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'), '') + '&' + sortkey + '=' + sortval.replace(/.*?=/, '');
    } else {
      url = url.replace(new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'), '') + '&' + sortkey + '=' + sortval.replace(/.*?#/, '');
    }

    list.attr('href', url)
    $('#updater').addLoader()
    ajaxUpdate(url, {}, '#updater')

    if (sortkey === 'orderby') {
      const icon = $(self).find('.sort-icon')
      if (url.match(/\|ASC$/)) {
        self.attr('href', url.replace(/\|ASC$/, '|DESC'))
        $('.sort-icon').attr('data-icon', 'angles-up-down')
        $(icon).attr('data-icon', 'chevron-up')
      } else {
        self.attr('href', url.replace(/\|DESC$/, '|ASC'))
        $('.sort-icon').attr('data-icon', 'angles-up-down')
        $(icon).attr('data-icon', 'chevron-down')
      }
    }

    self.closest('ul').find('.active').removeClass('active')
    self.addClass('active')

    return false
  })

  $('[data-sorter-select]').on('change', function (e) {
    e.preventDefault()

    const self = $(this),
      list = $('#currentlist'),
      sortkey = self.attr('name')

    let url = list.attr('href'),
      sortval = self.val(),
      valmatch = ''

    if (sortval) {
      valmatch = sortval.match(new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'));
    }

    if (valmatch) {
      sortval = valmatch[1] || '';
      url = url.replace(new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'), '') + '&' + sortkey + '=' + sortval.replace(/.*?=/, '')
    } else {
      url = url.replace(new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'), '') + '&' + sortkey + '=' + sortval.replace(/.*?#/, '')
    }

    list.attr('href', url)
    $('#updater').addLoader()
    ajaxUpdate(url, {}, '#updater')
    self.closest('ul').find('.active').removeClass('active')
    self.addClass('active')

    $('ul[rel].pagination ').each(function () {
      paginationLi.call(this)
    })

    return false
  })

  const sorterCheckbox = $('[data-sorter-checkbox]')
  sorterCheckbox.on('change', function (e) {
    e.preventDefault()

    const self = $(this),
      list = $('#currentlist'),
      sortkey = self.attr('name')

    let url = list.attr('href'),
      sortval = self.val(),
      valmatch = ''

    if (self.is(':checked')) {
      sortval = '1'
    } else {
      sortval = ''
    }

    if (sortval) {
      valmatch = sortval.match(
        new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?')
      )
    }
    if (valmatch) {
      sortval = valmatch[1] || ''
      url = url.replace(
        new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'),
        ''
      ) + '&' + sortkey + '=' + sortval.replace(/.*?=/, '')
    } else {
      url = url.replace(new RegExp('[&?]?' + sortkey.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") + '(=[^&]*)?'), '') + '&' + sortkey + '=' + sortval.replace(/.*?#/, '')
    }

    list.attr('href', url)
  })
  sorterCheckbox.on('click', function (e) {
    $(this).closest('.btn-group').addClass('show')
  })

  $(document).on('click', '#filter-apply', filterApply)
  $(document).on('click', '#filter-reset', filterReset)

  sorterCheckbox.each((i, obj) => $(obj).trigger('change'))

  if ($('.section-affiliates-newvoucher').length > 0) {
    $('#sfield').on('change', event => {
      const that = $(this),
        svalind = that.siblings('#slider_value_indicator').first(),
        margin = that.siblings('#slider_margin_indicator').first()
      svalind.html(fx.p + that.val() + fx.s)
      margin.html(fx.p + ((maxval - that.val()) + 2) + fx.s)

      /*
      const x = Math.floor(s.slider("value"))
          sval.val(x + 1).trigger('change')
          svalind.html(fx.p + (x + 1) + fx.s)
          margin.html(fx.p + ((maxval - x) + 1) + fx.s)
       */
    })
  }

  let confirm = {}
  $('.confirm_js').on('click', function (e) {
    const self = $(this)
    if (!confirm.all_done) {
      e.preventDefault()
      const message = $(self).attr('data-confirm')
      Swal.fire({
        text: message,
        icon: 'warning',
        confirmButtonText: jsLang.yes,
        cancelButtonText: jsLang.no,
        customClass: {
          confirmButton: 'btn btn-primary me-2',
          cancelButton: 'btn btn-danger',
        },
      }).then(({isConfirmed}) => {
        if (isConfirmed) {
          if ($(e.target).closest('a').length) {
            window.location.href = $(self).attr('href')
          } else {
            confirm.all_done = true
            $(self).trigger('click')
          }
        }
      })
    }
  })

  $('.affiliates_landing_input').on('keyup change input', function () {
    const t = $(this),
      v = t.val(),
      b = $('.affiliates_landing_btn'),
      domain = t.data('domain');
    if (v.length && !v.match(new RegExp("^https?://(.*\.)?" + domain + "/", 'i'))) {
      t.addClass('is-invalid')
      b.prop('disabled', true)
    } else {
      t.removeClass('is-invalid')
      b.prop('disabled', false)
    }
  })

  $('.affiliates_options').on('change', 'input, select, textarea', function () {
    const self = $(this),
      inp = self.parents('tr').eq(0).find('input, select, textarea')
    inp.prop('disabled', true)
    $.post(window.location.href, {
      make: 'options',
      name: self.attr('name'),
      value: self.val()
    }, function (data) {
      parseResponse(data)
      inp.prop('disabled', false)
    })
  })

  $('.domain-tld-checkbox-item').on('click', function () {
    const self = $(this),
      checkb = $(self).find('input[type="checkbox"]')

    if ($(checkb).is(':checked')) {
      $(checkb).prop('checked', false)
      $(self).removeClass('checked')

      $('.domain-tld-checkbox-all').removeClass('checked')
    } else {
      $(checkb).prop('checked', true)
      $(self).addClass('checked')
    }
  })

  $(document).on('click', '.domain-tld-checkbox-all', onSelectAllTld)
  $(document).on('keyup change', '.domain-tld-search', function () {
    const text = $(this).val(),
      domainTld = $('.domain-tld'),
      all = domainTld.find('.domain-tld-checkbox-item')
    if (text !== '') {
      const els = domainTld.find(".domain-tld-checkbox-item[data-tld*='" + text + "']");
      $(all).hide()
      $(els).show()
    } else {
      $(all).show()
    }
  })

  $('.fileupload').each(bindFileUpload)
  $('.language-change').on('click', onLanguageChange)
  $('.cf_item_description_selector').on('change', function () {
    const copy_of = $(this).attr('data-copy_of')
    let description = ''
    if (copy_of) {
      if ($(this).is('select')) {
        description = $(this).find('option:selected').attr('data-description')
      }
      $('.cf_'+copy_of+'_item_description_value').html(description)
    }
  })

  initCCard()

  let leftMenuLis = []

  const dropVmActionsApply = () => dropVmActions()
  function dropVmActions() {
    let menu = $('#vm-menu'),
      drop = [],
      avb_num = 4; //max 4, otherwise icon

    if(menu.length === 0){
      $('<div id="lockable-vm-menu"><ul id="vm-menu"></ul></div>').prependTo('#content-cloud')
      menu = $('#vm-menu')
    }

    if (!menu.data('parsed') && $('.section-main').hasClass('service-layout-top')) {
      menu.data('parsed', true)
      if ($.isEmptyObject(leftMenuLis)) {
        $('.cloud .cloud-top .cloud-nav ul li').each(function () {
          leftMenuLis.push($(this).prop('outerHTML'));
        });
        $('.cloud .cloud-top .cloud-nav').remove();
      }

      leftMenuLis.forEach(function (item) {
        menu.append(item);
      });
    }

    const items = menu.data('items') || menu.children('li')
    let avbWidth = menu.width() - 60

    menu.data('items', items);
    menu.append(items);
    menu.find('.vm-menu-dropdown').remove()

    if (window.toggleVmActionDrop !== undefined && window.toggleVmActionDrop === false) {
      return
    }

    items.each(function () {
      const self = $(this),
        width = self.width()

      if (avb_num < 1 || avbWidth - width < 0 || width < 50) {
        drop.push(self.detach())
      } else {
        avbWidth -= width
        avb_num -= 1
      }
    })

    if (!drop.length) {
      return true
    }

    const dropdown = $('<li class="vm-menu-dropdown">' +
      '<a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" data-flip="false" href="#" aria-expanded="true">' + jsLang.more + '<i class="fa-solid fa-ellipsis-vertical ms-3"></i></a>' +
      '<ul class="dropdown-menu dropdown-menu-end"></ul>' +
      '</li>')

    dropdown.find('.dropdown-menu').append(drop)
    menu.append(dropdown)
    menu.css({visibility: 'visible'})
  }

  const account = $('.section-account')
  account.find('.sso-container').hide()
  account.find('.signup-container').show()

  $(window).on('resize', debounce(dropVmActions))

  $(document).ready(dropVmActionsApply)
  $(document).on('cloud.loaded.actions', dropVmActionsApply)
  $(document).on('ajaxComplete', dropVmActions)

  const htmlEl = $('html')
  if (htmlEl.hasClass('loading')) {
    htmlEl.removeClass('loading')
  }

  const tableEl = $('table')
  if (tableEl.hasClass('form-inline')) {
    tableEl.removeClass('form-inline')
  }

  const trEl = $('tr')
  if (trEl.hasClass('form-inline')) {
    trEl.removeClass('form-inline')
  }

  const tdEl = $('td')
  if (tdEl.hasClass('form-inline')) {
    tdEl.removeClass('form-inline')
  }

  const saveEl = $('input[name="save"]')
  if (!saveEl.hasClass('btn-success')) {
    saveEl.addClass('btn-success')
  }

  const homeReturnEl = $('#lnkHomeReturn')
  if (!homeReturnEl.hasClass('btn-default')) {
    homeReturnEl.addClass('btn-default')
  }

  const widgetBtnEl = $('.widget .btn')
  if (
    !widgetBtnEl.hasClass('btn-primary')
    && !widgetBtnEl.hasClass('btn-default')
    && !widgetBtnEl.hasClass('btn-success')
  ) {
    widgetBtnEl.addClass('btn-primary')
  }

  const table = $('#dns-service table.dns-records, #dns-service table.dns-zones')
  $(table).addClass('table stackable')
  const td = $(table).find('tbody tr td:not(:last-child)')
  const th = $(table).find('tbody tr th:not(:last-child)')
  $(td).each(function () {
    const ind = $(this).index()
    $(this).attr('data-label', $(th).eq(ind).html())
  })
})
